module.exports = __webpack_public_path__ + "img/block.2a516ae7.png";